<template>
  <div class="dashboard-header">
    <div class="dashboard-header-left">
      <!-- <pondlogs-logo
        class="menu-icon"
        color="#0A2463"
        @click.native="toggleNavigation"
        v-if="!getSideNavStatus"
      ></pondlogs-logo>-->
      <portal-target name="destination"></portal-target>
    </div>
    <div class="dashboard-header-right">
      <portal-target name="rightdestination"></portal-target>
      <template v-if="!isUserOfTypeSuperAdmin">
        <er-dropdown
          v-if="doUserHasLocations"
          @item-click="handleChangeInLocation"
          trigger="click"
          :listOfItems="computedUserLocations"
        >
          <template slot="prefix">
            <i class="el-icon-location-icon">
              <img src="../../assets/dashboard/location.svg" />
            </i>
          </template>
          <template slot="title">
            <p>{{ currUserLocation.name }}</p>
          </template>
          <template v-slot:item-title="{ item }">{{
            item.value.name
          }}</template>
        </er-dropdown>
        <er-dropdown
          @item-click="handleChangeInLanguage"
          trigger="click"
          :listOfItems="langs"
        >
          <template slot="prefix">
            <i class="el-icon-lang">
              <img src="../../assets/home/lang-icon.svg" />
            </i>
          </template>
          <template slot="title">
            <p>{{ langSelected }}</p>
          </template>
        </er-dropdown>
      </template>
      <er-dropdown
        class="profile-drop-down"
        trigger="click"
        :listOfItems="profileDropDownItems"
        popper-class="profile-dropdown"
      >
        <template slot="prefix">
          <p class="header-profile-placeholder" v-if="!getProfileUrl">
            {{ getFirstCharsOfUserName }}
          </p>
          <el-avatar
            v-else
            class="header-profile-photo"
            :size="25"
            fit="fill"
            :src="getProfileUrl"
          >
            <!-- <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" /> -->
          </el-avatar>
        </template>
        <span class="el-dropdown-link" slot="title">{{ getUserName }}</span>
        <template slot="drop-down-items">
          <el-dropdown-item icon="el-icon-user-solid">
            <el-link
              class="truncate er-dropdown-item--profile"
              :underline="false"
              type="primary"
              href="/user/settings"
              :title="getUserName"
              >{{ $t("Usrs_profile") }}</el-link
            >
          </el-dropdown-item>
          <el-dropdown-item class="er-dropdown-item--logout">
            <i class="el-icon-logout">
              <img class="logout-icon" src="@/assets/logout.svg" />
            </i>
            <er-button
              class="logout-button"
              @click="handleSignOutClick"
              type="text"
            >
              <el-row type="flex">
                <el-col tag="div" class="button-text">{{
                  getLogoutBtnText
                }}</el-col>
              </el-row>
            </er-button>
          </el-dropdown-item>
        </template>
      </er-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { getImpersonationBy } from "@/middleware/auth";
export default {
  name: "Header",
  props: ["hideNavButton"],
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      query: {
        location_id: null,
        biomass_units: "KG",
        include: [
          "title",
          "pond_mothers",
          "shrimp_talks",
          "pond_guards",
          "status"
        ]
      },
      langs: { Español: "es", English: "en" },
      revLangs: { es: "Español", en: "English" },
      profileDropDownItems: {
        profile: "Profile",
        logout: "logout"
      }
    };
  },
  async mounted() {
    this.$moment.locale(this.$i18n.locale);
  },
  computed: {
    ...mapGetters("user", {
      userLocations: "getUserLocationsObj",
      getCurrUserLocation: "getCurrUserLocation",
      getProfileUrl: "getProfileUrl"
    }),
    ...mapGetters("header", {
      getSideNavStatus: "getSideNavStatus"
    }),
    getImpersonationBy,
    getLogoutBtnText() {
      const logoutButtonStr = {
        SUPER_ADMIN: "Back to SuperAdmin",
        ACCOUNT_MANAGER: "Back to Account Manager",
        DEALER: "Back to Dealer",
        USER: "Logout"
      };
      return this.getImpersonationBy === null
        ? logoutButtonStr.USER
        : logoutButtonStr[this.getImpersonationBy];
    },
    getFirstCharsOfUserName() {
      return (this.getUserName.match(/\b(\w)/g) || []).join("").slice(0, 2);
    },
    getUserName() {
      return (
        this.$store.getters["user/getUserProfile"] &&
        this.$store.getters["user/getUserProfile"].first_name +
          " " +
          this.$store.getters["user/getUserProfile"].last_name
      );
    },
    doUserHasLocations() {
      return Object.keys(this.computedUserLocations).length > 0;
    },
    computedUserLocations() {
      const sortedLocations = Object.values(this.userLocations).sort((a, b) =>
        this.$commonUtils.alphaNumericComparator(a.name, b.name)
      );
      const locationObj = {};
      sortedLocations.forEach(location => {
        locationObj[location._id] = location;
      });
      return locationObj;
    },
    currUserLocation() {
      return this.getCurrUserLocation;
    },
    langSelected() {
      return this.revLangs[this.$i18n.locale];
    }
  },
  methods: {
    ...mapActions("user", {
      setCurrUserLocation: "updateCurrUserLocation"
    }),
    ...mapActions("header", {
      changeSideNavStatus: "changeSideNavStatus"
    }),

    handleChangeInLanguage(value) {
      this.$i18n.locale = value;
      const indexPath = this.$route.meta.langKey;
      const appTitle = document.getElementById("appTitle");
      appTitle.innerHTML = `${this.$t(indexPath)} | PondLogs`;
      localStorage.setItem(`lang`, value);
    },
    handleChangeInLocation(updatedLocation) {
      this.setCurrUserLocation(updatedLocation);
      const path = this.$route.path;
      if (path.includes("resources-log")) {
        this.$router.push({
          path: "/user/resources-log",
          query: { location_id: updatedLocation._id }
        });
      }
    },
    navigate(pageName) {
      this.$router.push(pageName);
    },
    toggleNavigation: function() {
      this.changeSideNavStatus(!this.getSideNavStatus);
    },
    unregisterModules() {
      const storeModules = ["dashboard", "alertsInfo", "pondInfo"];
      storeModules.forEach(module => {
        if (this.$store.hasModule(module)) {
          this.$store.unregisterModule(module);
        }
      });
    },
    async handleSignOutClick() {
      switch (this.getImpersonationBy) {
        case "SUPER_ADMIN":
          await this.handleLoginAsSuperAdmin();
          break;
        case "DEALER":
          await this.handleLoginAsDealer();
          break;
        case "ACCOUNT_MANAGER":
          await this.handleLoginAsAccountManager();
          break;
        default:
          this.logout();
      }
    },
    logout() {
      const loading = this.$loading({
        fullscreen: true,
        text: this.$t("Comn_logout_loading")
      });
      this.unregisterModules();
      this.$store.dispatch("auth/signOut");
      this.$router.push("/sign-in");
      loading.close();
    },
    async handleLoginAsSuperAdmin() {
      const loading = this.$loading({
        fullscreen: true,
        text: this.$t("Comn_logout_loading")
      });
      this.unregisterModules();
      try {
        await this.$store.dispatch("auth/impersonationSignOut");
        await this.$store.dispatch("superadmin/loginAsSuperAdmin");
        this.$i18n.locale = "en";
        this.$router.replace("/admin/customers");
      } catch (err) {
        console.error(err);
        this.errorMessages(
          { response: { status: 401, data: { message: "Invalid Token" } } },
          false
        );
      } finally {
        loading.close();
      }
    },
    async handleLoginAsDealer() {
      const loading = this.$loading({
        fullscreen: true,
        text: this.$t("Comn_logout_loading")
      });
      this.unregisterModules();
      try {
        await this.$store.dispatch("auth/impersonationSignOut");
        await this.$store.dispatch("dealer/loginAsDealer");
        this.$i18n.locale = "en";
        this.$router.replace("/dealer/users");
      } catch (err) {
        console.error(err);
        this.errorMessages(
          { response: { status: 401, data: { message: "Invalid Token" } } },
          false
        );
      } finally {
        loading.close();
      }
    },
    async handleLoginAsAccountManager() {
      const loading = this.$loading({
        fullscreen: true,
        text: this.$t("Comn_logout_loading")
      });
      this.unregisterModules();
      try {
        await this.$store.dispatch("auth/impersonationSignOut");
        await this.$store.dispatch("accountManager/loginAsAccountManager");
        this.$i18n.locale = "en";
        this.$router.replace("/account-manager/users");
      } catch (err) {
        console.error(err);
        this.errorMessages(
          { response: { status: 401, data: { message: "Invalid Token" } } },
          false
        );
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style lang="scss">
.er-dropdown-item--profile {
  text-align: left;
  justify-content: left;
  width: 100%;
}
.er-dropdown-item--logout {
  .el-icon-logout {
    @include icon-size(svg, prefix);
  }
  .logout-button {
    padding: 0px;
    @include link-text-size;
  }
  img {
    transform: rotate(180deg);
  }
}

.dashboard-header {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .dashboard-header-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    & > img {
      margin-right: 35px;
    }
    .el-tabs__header {
      margin: 0px 15px;
    }
    .el-tabs__nav-wrap::after {
      background-color: unset;
    }
    .menu-icon {
      cursor: pointer;
      width: 30px;
      height: 30px;
      margin-right: 15px;
    }
    .el-tabs__item {
      height: var(--header-height);
      line-height: var(--header-height);
      font-size: $app_font_size_1;
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
    h1 {
      a {
        color: #333;
        text-decoration: none;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      img {
        width: 100%;
        box-sizing: border-box;
      }
    }
    .nav {
      float: right;
      list-style: none;
    }
    .portal-container {
      display: flex;
      .switch-container {
        display: flex;
        align-items: center;
        p {
          margin: auto;
          font-size: 0.7em;
          @include responsiveProperty(font-size, 1em, 1em, 0.7em);
        }

        .el-switch {
          margin-left: 0.5rem;
        }
        @media only screen and (max-width: 1440px) {
          p {
            font-size: 1em;
          }
          margin-left: 0.8rem;
        }

        .el-switch.is-checked .el-switch__core {
          background: rgb(80, 143, 244);
          background: linear-gradient(
            90deg,
            rgba(80, 143, 244, 1) 0%,
            rgba(19, 101, 187, 1) 70%
          );
        }
      }
      .el-header {
        position: relative;
        margin-bottom: 2.5rem;
      }

      @media only screen and (max-width: 1440px) {
        .el-header {
          margin-bottom: 4.5rem;
        }
      }
      .is-active {
        .tab-label__content-dashboard,
        .tab-label__content-pond,
        .tab-label__content-alerts {
          color: #0a2463;
          opacity: 1;
          font-weight: 600;
        }
      }
      .tab-label__content-dashboard,
      .tab-label__content-pond,
      .tab-label__content-alerts {
        color: #0a2463;
        opacity: 0.8;
      }
      .el-tabs__active-bar {
        color: #0a2463;
        background-color: #0a2463;
      }
      .el-tabs__item:hover {
        .tab-label__content-dashboard,
        .tab-label__content-pond,
        .tab-label__content-alerts {
          color: #0a2463;
          opacity: 1;
        }
      }
      .tab-label__content {
        margin-left: 10px;
        // line-height: 2.2;
      }
      .tab-label__content-dashboard,
      .tab-label__content-alerts,
      .tab-label__content-pond {
        margin-left: 15px;
        // line-height: 2.2;
      }

      .tab-header {
        color: #0a2463;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding-right: 15px;
        opacity: 1;
      }
      .el-tabs__item {
        padding: 0 5px;
      }
    }
  }
  .dashboard-header-right {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    & > div {
      margin: 0px 10px;
    }
    .logout-button {
      @include link-text-size;
    }
    .location-picker {
      max-width: 130px;
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
    .profile-drop-down {
      display: inline-flex;
      a {
        max-width: 200px;
        text-transform: capitalize;
        text-decoration: none;
        line-height: 24px;
        letter-spacing: 0.6494286px;
        color: #41516a;
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
      }
      .header-profile-placeholder {
        padding: 5px;
        background: #e0e4ea;
        clip-path: circle(47% at 50% 50%);
        text-align: center;
        display: inline-flex;
      }
      .header-profile-photo {
        img {
          display: inline-block;
        }
      }
      .logout__icon {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .user-menu {
      list-style: none;
    }
    .el-icon-logout {
      @include icon-size(svg, prefix);
      transform: rotate(180deg);
    }
    .user-logout-divider {
      @include responsiveProperty(
        font-size,
        1.5 * $app_font_size_1,
        1.5 * $app_font_size_2,
        1.5 * $app_font_size_3
      );
    }
    .el-icon-logout img {
      @include icon-size(svg, prefix);
    }

    .el-icon-lang img,
    .el-icon-location-icon img {
      @include icon-size(svg, prefix);
    }
    .logout-button {
      .button-text {
        display: inline-flex;
        align-items: center;
      }
    }
  }
}
</style>
